export default __webpack_public_path__ + "static/media/piraten_dark.1ba93b14.png";